import { MuiTheme, breakpoints, button } from 'assets/theme';

import background from 'assets/img/home/home-bg.jpg';
import imgSectionBg from 'assets/img/home/homepage_img.jpg';
import HomePageSharedStyle from './HomePageSharedStyle';

const { titleText } = HomePageSharedStyle

const HomePageStyle = theme => ({
  mainBg: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: -1,
    objectFit: 'cover',
  },
  imgSectionBg: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    zIndex: -1,
    objectFit: 'cover'
  },
  emphasis: {
    fontWeight: 'bold',
    textDecoration: 'underline'
  },
  bold: {
    fontWeight: 'bold'
  },
  typingContainer: {
    marginBottom: '80px',
    marginTop: '80px',
    background: 'rgba(0,0,0,0.5)',
    borderRadius: "5px",
    padding: "32px",

    [theme.breakpoints.down('xs')]: {
      padding: '5px',
      marginBottom: "40px",
    }
  },
  mainTitleText: {
    color: 'white',
    marginBottom: '80px',
    fontWeight: '500'
  },
  getStartedButton: {
    ...button,
    margin: '10px 0 0 0'
  },
  getStartedButton2: {
    ...button,
    '&:hover': {
      background: MuiTheme.palette.secondary.dark,
      color: MuiTheme.palette.common.black
    },
    background: MuiTheme.palette.common.black,
    color: MuiTheme.palette.secondary.main,
  },
  headerText1: {
    ...titleText,
    color: MuiTheme.palette.common.white,
    marginBottom: "8px",
    fontSize: "1.8rem",

    [theme.breakpoints.down('xs')]: {
      fontSize: "1.0rem",
    }
  },
  headerText3: {
    ...titleText,
    fontWeight: 'bold',
  },
  headerText4: {
    ...titleText,
    fontWeight: 'bold',
    fontSize: '1.6rem'
  },
  headerText5: {
    ...titleText,
    fontSize: '2rem',
    marginBottom: '15px'
  },
  headerText6: {
    ...titleText,
    color: MuiTheme.palette.secondary.main,
    fontSize: "1.65rem",

    [theme.breakpoints.down('xs')]: {
      fontSize: "0.9rem",
    }
  },
  container1: {
    height: '650px',
    // background: `url(${background}) no-repeat`,
    // backgroundSize: 'cover',
    // backgroundPosition: 'center',
    position: 'relative',

    [theme.breakpoints.down('xs')]: {
      height: '450px',
    }
  },
  container2: {
    minHeight: '150px',
    marginTop: '30px'
  },
  container3: {
    minHeight: '400px',
    margin: '0px 80px'
  },
  innerTestimonialContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'stretch',
    marginTop: '35px',
    flexWrap: 'wrap',
    margin: '0px 80px',

    '& > *': {
      margin: '10px 10px'
    }
  },
  testimonialContainer: {
    minHeight: '300px',
    width: '100% !important',
  },
  container4: {
    minHeight: '240px',
    margin: '30px 0',
    marginBottom: '0',
    padding: '30px 0',
    boxSizing: 'border-box',
    background: MuiTheme.palette.secondary.main
  },
  container4Inner: {
    width: '90%',
    margin: 'auto'
  },
  container4Alt: {
    minHeight: '240px',
    padding: '30px 0',
    boxSizing: 'border-box',
    background: MuiTheme.palette.secondary.main
  },
  bannerContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "30px",
  },
  bannerImage: {
    width: "150px",
    height: "55px",
    margin: "8px",
  },
  bannerImage2: {
    height: "65px",
    width: "100px",
  },
  bannerImage3: {
    height: "45px",
    width: "150px",
  },
  bannerImage5: {
    height: "65px",
    width: "125px",
  },
  addIcon: {
    height: "55px",
    width: "100px",
    color: MuiTheme.palette.common.black
  },
  container5: {
    marginTop: '30px',
    minHeight: '360px'
  },
  container6: {
    minHeight: '200px',
    paddingBottom: '40px',
    marginBottom: '30px',
    marginTop: '30px'
  },
  arrowIcon: {
    fontSize: '150px',
    display: 'block',
    margin: 'auto',
    color: 'black',
    position: 'relative',
    top: '30px'
  },
  testimonial: {
    backgroundColor: '#EEEEEE',
    minHeight: '200px',
    width: '300px',
    padding: '25px',
    borderRadius: '8px',

    WebkitBoxShadow: "2px 2px 3px 0px rgba(0,0,0,0.25)",
    MozBoxShadow: "2px 2px 3px 0px rgba(0,0,0,0.25)",
    boxShadow: "2px 2px 3px 0px rgba(0,0,0,0.25)"
  },
  covidUpdate: {
    background: '#FFE001',
    color: 'black',
    width: '100%',
    marginTop: '0px',
    padding: '10px',
    WebkitBoxShadow: "2px 2px 3px 0px rgba(0,0,0,0.25)",
    MozBoxShadow: "2px 2px 3px 0px rgba(0,0,0,0.25)",
    boxShadow: "2px 2px 3px 0px rgba(0,0,0,0.25)"
  },
  testimonialTitle: {
    fontWeight: '600',
    fontSize: '27px',
    color: 'black',
    marginBottom: '20px',
    position: 'relative',
    paddingBottom: '11px',
    lineHeight: '34px',

    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: '0px',
      left: '0px',
      height: '3px',
      backgroundColor: 'black',
      width: '80px'
    }
  },
  testimonialFooter: {
    marginTop: '12px',
    color: '#878787'
  },
  googleReviewContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  googleIcon:{
    width: "30px",
    height: "30px",
    marginRight: "8px",
    position: "relative",
    top: 5,
  },
  pseudoLink: {
    color: 'black',
    cursor: 'pointer',
    textDecoration: 'underline'
  },
  typingCursor: {
    color: MuiTheme.palette.secondary.main
  },
  imgSection: {
    // background: `linear-gradient(rgba(0, 0, 0, 0.1),
    //   rgba(0, 0, 0, 0.1)), url(${imgSectionBg}) no-repeat`,
    // backgroundSize: '100% 100%',
    // backgroundPosition: 'center',
    position: 'relative',
    padding: '60px',
    minHeight: '800px',
    marginBottom: '40px'
  },
  imgSectionHeader: {
    color: 'white',
    fontWeight: 'bold',
    maxWidth: '430px',
    textAlign: 'center',
    fontSize: '2.6rem'
  },

  [breakpoints.large]: {
    arrowIcon: {
      fontSize: '150px',
      top: '0px',
      transform: 'rotate(90deg)',
    },
  },
  [breakpoints.medium]: {
    container1: {
      backgroundSize: 'cover'
    },
    imgSection: {
      padding: '60px',
      minHeight: '600px',
      marginBottom: '40px'
    }
  },
  [breakpoints.small]: {
    container3: {
      margin: '0 30px'
    },
    headerText2: {
      fontSize: '1.5rem',
    },
    headerText3: {
      fontSize: '1.5rem',
    },
    headerText4: {
      fontSize: '1.5rem',
      marginBottom: '0'
    },
    headerText5: {
      fontSize: '1.2rem',
    },
    getStartedButton: {
      fontSize: '1rem',
    },
    getStartedButton2: {
      fontSize: '1rem',
    },
    imgSection: {
      padding: '60px',
      minHeight: '300px',
      marginBottom: '40px'
    },
    imgSectionHeader: {
      fontSize: '1.55rem'
    },

    innerTestimonialContainer: {
      margin: '0px 20px'
    },

    covidUpdateText: {
      fontSize: '0.6rem'
    }
  },
});

export default HomePageStyle;
